import styled from 'styled-components';

import { MediaQuery, Transition } from '../../../../../../constants/Styles';

export const ContentWrapper = styled.div`
  & > :not(:first-child) {
    padding: 20px 30px;

    svg {
      font-size: 12px;
      padding-left: 5px;
    }
  }
`;

export const SectionWrapper = styled.div`
  display: flex;

  ${MediaQuery.L_AND_DOWN} {
    display: block;
  }
`;

export const MainContainer = styled.div`
  display: flex;

  button {
    align-items: center;
  }

  svg {
    padding-left: 5px;
    transition: ${({ isOpen }) => isOpen && Transition.ALL_EASE};
    transform: ${({ isOpen }) => isOpen && `translate(25%) rotate(-180deg)`};
  }
`;
